module.exports = __webpack_public_path__ + "img/main_background_city_offlineGame_mobile.9c2630d8.svg";